interface KeyWord {
    value: string;
    weight: number;
}

interface BodyPart {
    partType: string;
    text: string;
    href: string;
  }

export default class FrequentlyAskedQuestion {  
  constructor(
      readonly answerBody: Array<BodyPart>,
      readonly categories: Array<string>,
      readonly keyWords: Array<KeyWord>,
      readonly questionText: string,
  ) {

  }
}